import { createContext, useContext } from 'react';

export interface EditorNavSlotValue {
  /**
   * DOM node of the full-width top-nav slot (rendered by `SessionDetailLayout`). The editor
   * portals its `ClipHeader` into it. A React portal preserves context, so the portaled
   * `ClipHeader` keeps its `ClipsContext` even though it renders into a node owned by an
   * ancestor above the router `<Outlet />`. Null when there is no provider (e.g. isolated
   * tests) — consumers should then fall back to rendering the nav inline.
   */
  navSlotEl: HTMLElement | null;
  /**
   * The editor calls this to tell the layout a top nav is mounted, so the layout can drop the
   * back button from the left rail (it now lives in the nav). No-op without a provider.
   */
  setHasNav: (hasNav: boolean) => void;
}

const EditorNavSlotContext = createContext<EditorNavSlotValue>({
  navSlotEl: null,
  setHasNav: () => undefined
});

export const EditorNavSlotProvider = EditorNavSlotContext.Provider;

export function useEditorNavSlot(): EditorNavSlotValue {
  return useContext(EditorNavSlotContext);
}
